module.exports = __webpack_public_path__ + "static/media/protect-1.5da16102.png";